import { render, staticRenderFns } from "./AttachmentUploader.vue?vue&type=template&id=4502821c&scoped=true"
import script from "./AttachmentUploader.vue?vue&type=script&lang=js"
export * from "./AttachmentUploader.vue?vue&type=script&lang=js"
import style0 from "./AttachmentUploader.vue?vue&type=style&index=0&id=4502821c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4502821c",
  null
  
)

export default component.exports